import { createIcon } from '@chakra-ui/icons';

export const AuthoringScorm = createIcon({
  displayName: 'AuthoringScorm',
  viewBox: '0 0 44 44',
  path: [
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4794_24118)">
        <path
          d="M0.655273 21.9993C0.655273 38.4302 18.4423 48.6996 32.6719 40.4841C39.2759 36.6713 43.3441 29.6249 43.3441 21.9993C43.3441 5.56837 25.5571 -4.70099 11.3275 3.51452C4.72347 7.32732 0.655273 14.3737 0.655273 21.9993Z"
          fill="#FADFB2"
        />
        <path
          d="M18.2258 21.5489L15.3635 26.5584C15.0167 27.1651 15.4548 27.9201 16.1536 27.92H19.7146C20.33 27.9195 20.7682 28.5177 20.5822 29.1044L18.9606 34.2404C18.8544 34.574 19.1492 34.8974 19.4912 34.8225C19.5933 34.8002 19.6846 34.7433 19.7497 34.6615L26.1445 26.6684C26.5821 26.1209 26.2629 25.305 25.5699 25.1998C25.5249 25.193 25.4795 25.1895 25.434 25.1895H23.7943C23.1177 25.1895 22.6777 24.4774 22.9805 23.8723L24.1421 21.5469L18.2258 21.5489Z"
          fill="white"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.225 13.2891C32.8878 10.5813 30.3708 8.17139 27.6944 8.95124C27.2626 9.07703 26.8581 9.28217 26.5014 9.55611C22.8772 5.28419 15.9876 6.53752 14.1001 11.8121C13.8181 12.6 13.6742 13.4306 13.6746 14.2673V14.3139C13.5233 14.2884 13.3706 14.2728 13.2173 14.2673C10.4148 14.2643 8.65998 17.2962 10.0586 19.7247C10.7091 20.8543 11.9138 21.5498 13.2173 21.5484H29.5983C33.0966 21.5556 35.2908 17.7732 33.5479 14.74C33.2179 14.1658 32.7664 13.6706 32.225 13.2891Z"
          fill="#F1CA89"
        />
        <path
          d="M32.225 13.2891C32.8878 10.5813 30.3708 8.17139 27.6944 8.95124C27.2626 9.07703 26.8581 9.28217 26.5014 9.55611C22.8772 5.28419 15.9876 6.53752 14.1001 11.8121C13.8181 12.6 13.6742 13.4306 13.6746 14.2673V14.3139C13.5233 14.2884 13.3706 14.2728 13.2173 14.2673C10.4148 14.2643 8.65998 17.2962 10.0586 19.7247C10.7091 20.8543 11.9138 21.5498 13.2173 21.5484H29.5983C33.0966 21.5556 35.2908 17.7732 33.5479 14.74C33.2179 14.1658 32.7664 13.6706 32.225 13.2891Z"
          stroke="#535353"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.2628 39.8036C24.6698 39.8036 27.4319 39.3946 27.4319 38.8901C27.4319 38.3856 24.6698 37.9766 21.2628 37.9766C17.8557 37.9766 15.0938 38.3855 15.0938 38.8901C15.0938 39.3947 17.8557 39.8036 21.2628 39.8036Z"
          fill="#EBBF76"
        />
      </g>
      <defs>
        <clipPath id="clip0_4794_24118">
          <rect width="44" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
